import {LOADED, LOADING} from "./constants";


export const startLoading = () => {
    return { type: LOADING, payload: true }
};

export const stopLoading = () => {
    return { type: LOADED, payload: false }
};